/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Select_Saved_AddressInputs */

const en_orders_select_saved_address = /** @type {(inputs: Orders_Select_Saved_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select saved address or add a new one`)
};

const es_orders_select_saved_address = /** @type {(inputs: Orders_Select_Saved_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona una direccion guardada o agrega una nueva`)
};

/**
* | output |
* | --- |
* | "Select saved address or add a new one" |
*
* @param {Orders_Select_Saved_AddressInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_select_saved_address = /** @type {((inputs?: Orders_Select_Saved_AddressInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Select_Saved_AddressInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_select_saved_address(inputs)
	return es_orders_select_saved_address(inputs)
});